import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BlockBackButton = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Disable the back button using pushState
    window.history.pushState(null, "", window.location.href);

    const handlePopState = (event) => {
      // When the user tries to go back, we push a new state and navigate to the desired page
      window.history.pushState(null, "", window.location.href);
      navigate("/"); // Redirect to home page or any page you prefer
    };

    window.addEventListener("popstate", handlePopState);

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <div>
     
      {/* Your content goes here */}
    </div>
  );
};

export default BlockBackButton;
